import { generateBulkCampaignsGroupEditorPath } from 'modules/campaigns/services/utils';
import { mergeQueryParams } from '../../../../taboola-common-frontend-modules/query-params';
import { BULK_EDIT_CAMPAIGNS_GROUP } from '../../campaigns-group-form/forms/campaigns-group-bulk-editor/hooks/useBulkEditCampaignsGroupIds';

export const bulkEditCampaignsGroup =
    ({ navigate, accountId, selectedRowsIds }) =>
    () => {
        const bulkEditCampaignsGroupPath = generateBulkCampaignsGroupEditorPath({
            accountId,
        });
        const pathWithQuery = `${bulkEditCampaignsGroupPath}${mergeQueryParams('', {
            [BULK_EDIT_CAMPAIGNS_GROUP]: selectedRowsIds,
        })}`;

        navigate(pathWithQuery);
    };
